// stores/games/gamesStore.js
import { defineStore } from 'pinia';
import { gamesApi } from '../../services/api';
import config from '../../config'; 
import { useWebSocketStore } from '../websocket/websocketStore';


export const useGamesStore = defineStore('games', {
  state: () => ({
    games: [],
    allGames: [],
    featuredGames: [],
     favoriteGames: [],
    currentGame: null,
    activeGame: null,
    isLaunching: false,
    currentPage: 1,
    gamesPerPage: 30,
    notificationMessage: null,
    notificationShow: false
  }),

  actions: {
    getGameImageUrl(game) {
      if (!game.cover) return null;
      if (game.cover.includes('static.cdneu-stat.com')) return game.cover;
      if (game.cover.startsWith('http')) return game.cover;
      return `${config.storageUrl}/${game.distribution}/${game.cover}`;
    },

    async loadFeaturedGames() {
      try {
        //console.log('Loading featured games...');
        const response = await gamesApi.get('/games/featured');
        
        if (response.data.featured_games) {
          this.featuredGames = response.data.featured_games.map(game => ({
            ...game,
            image_url: this.getGameImageUrl(game)
          }));
         // console.log('Featured games loaded:', this.featuredGames);
        }
      } catch (error) {
        console.error('Error loading featured games:', error);
      }
    },
   // Añadir esta función al gamesStore
   async toggleFavorite(gameId) {
    try {
      const response = await gamesApi.post(`/games/favorites/${gameId}`);
      console.log('Respuesta toggle favorito:', response.data);
      
      // Actualizar UI inmediatamente si hay respuesta exitosa
      if (response.data.status && response.data.is_favorite !== undefined) {
        const updateGameInCollection = (collection) => {
          return collection.map(game => 
            game.id === gameId 
              ? {...game, is_favorite: response.data.is_favorite} 
              : game
          );
        };
        
        this.games = updateGameInCollection(this.games);
        this.allGames = updateGameInCollection(this.allGames);
        this.featuredGames = updateGameInCollection(this.featuredGames);
      }
      
      return response.data;
    } catch (error) {
      console.error('Error en toggle favorito:', error);
      throw error;
    }
  },

// Función auxiliar para actualizar todas las colecciones
updateGamesWithFavorites(favoriteIds) {
  if (!favoriteIds || !favoriteIds.length) return;
  
  // Crear Set para búsqueda eficiente
  const favoritesSet = new Set(favoriteIds);
  
  // Función para actualizar una colección
  const updateCollection = (collection) => {
    return collection.map(game => ({
      ...game,
      is_favorite: favoritesSet.has(game.id)
    }));
  };
  
  // Actualizar todas las colecciones
  this.games = updateCollection(this.games);
  this.allGames = updateCollection(this.allGames);
  this.featuredGames = updateCollection(this.featuredGames);
},

// Corregir updateFavoritesFromEvent para que funcione con la estructura del backend
updateFavoritesFromEvent(favorites) {
  if (!favorites) return;
  
  console.log('⚡ Recibido evento de favoritos:', favorites);
  this.favoriteGames = Array.isArray(favorites) ? favorites : [];
  this.updateGamesWithFavorites(this.favoriteGames);
},
    async loadGames() {
      try {
        await Promise.all([
          this.loadFeaturedGames(),
          (async () => {
            const response = await gamesApi.get('/games/all', {
              params: {
                page: this.currentPage,
                per_page: this.gamesPerPage
              }
            });
            
            //console.log('Raw providers response:', response.data.providers);
    
            if (response.data.providers) {
              const games = response.data.providers.flatMap(provider => {
                //console.log('Processing provider:', provider.name, provider.code);
                return provider.games.map(game => {
                  //console.log('Game provider data:', game.provider);
                  return {
                    ...game,
                    provider: {
                      id: provider.id,
                      name: provider.name,
                      code: provider.code
                    },
                    image_url: this.getGameImageUrl(game)
                  };
                });
              
              });
              // Sorting logic
              const sortedGames = games.sort((a, b) => {
                if (a.is_featured !== b.is_featured) return b.is_featured ? 1 : -1;
                return b.views - a.views;
              });
              
              this.allGames = sortedGames;
              this.games = sortedGames;
            }
          })()
        ]);
      } catch (error) {
        console.error('Error loading games:', error);
      }
    },
    

    async launchGame(gameId) {
      try {
        const game = this.games.find(g => g.id === gameId);
        if (!game) throw new Error(`Game not found: ${gameId}`);
        
        const response = await gamesApi.get(`/games/${gameId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        
        // Si hay error de balance, actualizamos el estado
        if (response.data.error === 'need_balance_to_launch') {
          this.notificationMessage = 'errors.need_balance_to_launch';
          this.notificationShow = true;
        }
        console.log('Respuesta del servidor balance:', response.data);
        this.activeGame = response.data;
         // AGREGAR - Iniciar verificación cuando se abre juego
      const wsStore = useWebSocketStore();
      wsStore.checkInactivity();
        return response.data;
      } catch (error) {
        console.error('❌ Game launch error:', error);
        throw error;
      }
    },

    clearNotification() {
      this.notificationMessage = null;
      this.notificationShow = false;
    },

    closeGame() {
      // AGREGAR - Detener verificación cuando se cierra
  const wsStore = useWebSocketStore();
  if (wsStore.inactivityTimer) {
    clearInterval(wsStore.inactivityTimer);
    wsStore.inactivityTimer = null;
  }
      this.activeGame = null;
      this.isLaunching = false;
    },
    async filterGamesByCategory(categorySlug) {
      try {
        if (categorySlug === 'all-games') {
          return this.loadGames();
        }
        
        // Si es la categoría de favoritos, filtrar por favoritos
        if (categorySlug === 'favorites' || categorySlug === 'favorite' || categorySlug === 'Favorite') {
          // Ahora los juegos ya vienen con is_favorite marcado desde el backend
          this.games = this.allGames.filter(game => game.is_favorite);
          return;
        }
        const response = await gamesApi.get(`/games/category/${categorySlug}`);
        if (response.data.providers) {
          this.games = response.data.providers.flatMap(provider =>
            provider.games.map(game => ({
              ...game,
              name: game.game_name,
              image_url: this.getGameImageUrl(game)
            }))
          );
          
          // Actualizar estado de favoritos en los juegos filtrados
          if (this.favoriteGames.length > 0) {
            this.updateGamesWithFavorites(this.favoriteGames);
          }
        }
      } catch (error) {
        console.error('Error filtering games:', error);
      }
    },

    async searchGamesByName(term) {
      try {
        const response = await gamesApi.get('/games/all', {
          params: { searchTerm: term }
        });
        
        if (response.data.providers) {
          const allGames = response.data.providers.flatMap(provider => {
            if (provider.games && Array.isArray(provider.games)) {
              return provider.games
                .filter(game => 
                  game.game_name.toLowerCase().includes(term.toLowerCase()) ||
                  game.game_code.toLowerCase().includes(term.toLowerCase())
                )
                .map(game => ({
                  ...game,
                  image_url: this.getGameImageUrl(game)
                }));
            }
            return [];
          });

          this.games = allGames.sort((a, b) => {
            if (a.is_featured !== b.is_featured) return b.is_featured ? 1 : -1;
            return b.views - a.views;
          });
        }
      } catch (error) {
        console.error('Error searching games:', error);
      }
    },

    async filterGamesByProvider(providerCode) {
      try {
        if (providerCode === 'all') {
          return this.loadGames();
        }
        
        const response = await gamesApi.get(`/games/filter/provider/${providerCode}`);
        if (response.data.providers && response.data.providers[0]?.games) {
          this.games = response.data.providers[0].games.map(game => ({
            ...game,
            image_url: this.getGameImageUrl(game)
          }));
        }
      } catch (error) {
        console.error('Error filtering provider games:', error);
      }
    },

    updateGamesFromSocket(games) {
      this.games = games.map(game => ({
        ...game,
        image_url: this.getGameImageUrl(game)
      }));
    },

   
  },

  getters: {
    isGameActive: (state) => !!state.activeGame,
    getFavoriteGames: (state) => state.games.filter(game => game.is_favorite)
  }
});